<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Create Order'"
      [canGoBack]="true"
      [customBack]="'restocking'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #cartCard let-line="line">
  <tidy-card>
    <div class="restock-line-row restock-line-top">
      <tidy-image
        [src]="line.icon"
        class="body-size" />
      <tidy-text
        [body]="line.name"
        class="bold" />
      <span class="restock-spacer"></span>
      <div class="restock-qty-controls">
        <tidy-small-button
          [smallIconButton]="true"
          [image]="'assets/svg/remove-outline.svg'"
          (buttonClick)="decrementQty(line)" />
        <tidy-text
          [body]="line.qtyText" />
        <tidy-small-button
          [smallIconButton]="true"
          [image]="'assets/svg/add-outline.svg'"
          (buttonClick)="incrementQty(line)" />
        <div
          class="restock-trash"
          (click)="removeLine(line)"></div>
      </div>
    </div>
    <div class="restock-line-row">
      <tidy-text
        [body]="line.headerHelper" />
    </div>
    @if (line.hasBrands) {
      <div class="restock-line-row restock-first-choice">
        @if (line.backups.length > 0) {
          <tidy-image
            [src]="line.showBackups ? 'assets/svg/chevron-up-outline.svg' : 'assets/svg/chevron-down-outline.svg'"
            (action)="toggleBackups(line)"
            class="body-size restock-icon-action" />
        }
        <tidy-text
          [helper]="line.firstChoiceText" />
      </div>
      @if (line.showBackups) {
        @for (backup of line.backups; track backup.text) {
          <div class="restock-line-row restock-indent">
            <tidy-text
              [helper]="backup.text" />
          </div>
        }
      }
    }
    @if (line.needsSetup) {
      <tidy-alert
        class="restock-setup-alert"
        (click)="line.goToItem()">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/alert-circle-outline.svg'"
            class="body-size" />
          <tidy-text
            [body]="line.setupText" />
          <span class="restock-spacer"></span>
          <tidy-image
            [src]="'assets/svg/chevron-forward-outline.svg'"
            class="body-size" />
        </tidy-row>
      </tidy-alert>
    }
  </tidy-card>
</ng-template>

<ng-template #moreCard let-line="line">
  <tidy-card>
    <div class="restock-line-row restock-line-top">
      <tidy-image
        [src]="line.icon"
        class="body-size" />
      <tidy-text
        [body]="line.name"
        class="bold" />
      <span class="restock-spacer"></span>
      <tidy-small-button
        [smallIconButton]="true"
        [image]="'assets/svg/add-outline.svg'"
        (buttonClick)="addLine(line)" />
    </div>
    <div class="restock-line-row">
      <tidy-text
        [body]="line.headerHelper" />
    </div>
  </tidy-card>
</ng-template>

<!-- Loading skeleton: mirrors the real cart cards (icon + name + quantity
     steppers, helper line, first-choice line) under a grey section
     header, so the data swaps in without shifting. -->
<ng-template #itemsSkeleton>
  <div class="restock-skeleton">
    <div class="restock-line-row restock-skel-section">
      <ion-skeleton-text [animated]="true" class="restock-skel-header" />
    </div>
    @for (row of skeletonRows; track row) {
      <tidy-card>
        <div class="restock-line-row restock-line-top">
          <ion-skeleton-text [animated]="true" class="restock-skel-icon" />
          <ion-skeleton-text [animated]="true" class="restock-skel-name" />
          <span class="restock-spacer"></span>
          <ion-skeleton-text [animated]="true" class="restock-skel-qty" />
        </div>
        <div class="restock-line-row">
          <ion-skeleton-text [animated]="true" class="restock-skel-text" />
        </div>
        <div class="restock-line-row">
          <ion-skeleton-text [animated]="true" class="restock-skel-text-sm" />
        </div>
      </tidy-card>
    }
  </div>
</ng-template>

<ng-template #content>
  @if (loaded && !itemsLoading) {
    <div class="restock-sticky-header">
      <tidy-wrapper>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text
            [title]="'Total'" />
          <tidy-text
            [helper]="'Updated once ordered'" />
        </tidy-row>
        <tidy-button
          [text]="submitButtonText"
          [action]="boundSubmit"
          [disabled]="submitDisabled"
          class="primary full-width" />
        <tidy-row [align]="'center'">
          <tidy-text
            [helper]="'Concierge will order your items and manage restocking'" />
        </tidy-row>
      </tidy-wrapper>
    </div>
  } @else if (!loaded || itemsLoading) {
    <!-- Real labels over grey values, so the summary doesn't vanish while
         the cart loads or the property switches. -->
    <div class="restock-sticky-header restock-skeleton">
      <tidy-wrapper>
        <div class="restock-line-row">
          <tidy-text
            [title]="'Total'" />
          <span class="restock-spacer"></span>
          <ion-skeleton-text [animated]="true" class="restock-skel-text-sm" />
        </div>
        <ion-skeleton-text [animated]="true" class="restock-skel-btn" />
        <div class="restock-line-row restock-skel-center">
          <tidy-text
            [helper]="'Concierge will order your items and manage restocking'" />
        </div>
      </tidy-wrapper>
    </div>
  }
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      @if (propertyItems.length > 0) {
        <tidy-row>
          <form [formGroup]="propertyForm" novalidate action="#">
            <tidy-filter
              formControlName="property"
              [items]="propertyItems"
              [fitContent]="true"
              [initValue]="propertyId"
              (optionChange)="changeProperty()"
              class="align-center" />
          </form>
        </tidy-row>
      }

      @if (itemsLoading) {
        <ng-container *ngTemplateOutlet="itemsSkeleton" />
      } @else {
        <tidy-row>
          <tidy-text
            [header]="'Low Stock'" />
        </tidy-row>
        @if (lowLines.length > 0) {
          @for (line of lowLines; track line.roomObjectId) {
            <ng-container *ngTemplateOutlet="cartCard; context: { line: line }" />
          }
        } @else {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No items are below their min level right now. You can still add items manually below.'" />
            </tidy-row>
          </tidy-alert>
        }

        <tidy-row>
          <tidy-text
            [header]="'Below Opportunistic Level'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'Not urgent, but below the level you\'d top up when already placing an order.'" />
        </tidy-row>
        @if (opportunisticLines.length > 0) {
          @for (line of opportunisticLines; track line.roomObjectId) {
            <ng-container *ngTemplateOutlet="cartCard; context: { line: line }" />
          }
        } @else {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No items are below their opportunistic level right now.'" />
            </tidy-row>
          </tidy-alert>
        }

        @if (addedLines.length > 0) {
          <tidy-row>
            <tidy-text
              [header]="'Added by You'" />
          </tidy-row>
          @for (line of addedLines; track line.roomObjectId) {
            <ng-container *ngTemplateOutlet="cartCard; context: { line: line }" />
          }
        }

        <tidy-row>
          <tidy-text
            [header]="'Add More Items'" />
        </tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'"
            class="header-search" />
        </form>
        @for (line of visibleMoreLines; track line.roomObjectId) {
          <ng-container *ngTemplateOutlet="moreCard; context: { line: line }" />
        }
        @if (hasMoreToShow) {
          <tidy-row [align]="'center'">
            <tidy-text
              [actionBody]="'View more'"
              (action)="viewMore()"
              class="white-link" />
          </tidy-row>
        }
      }
    } @else {
      <div class="restock-skeleton restock-line-row restock-skel-center">
        <ion-skeleton-text [animated]="true" class="restock-skel-pill" />
      </div>
      <ng-container *ngTemplateOutlet="itemsSkeleton" />
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
